import React, { useEffect, useState } from "react";
import "./App.css";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
} from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import LoginPage from "./components/pages/LoginPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import { setUsername } from "./store/appInfo/data/action";
import { useDispatch } from "react-redux";
import ArchiveDataPage from "./components/pages/ArchiveDataPage";
import HeliportsPage from "./components/pages/HeliportsPage";
import RegionPage from "./components/pages/RegionPage";
import DashboardPage from "./components/layout/DashboardPage";
import moment from "moment";
import Environment from "./environment";
import { TailSpin } from "react-loader-spinner";
import ArchivePhotoDetailPage from "./components/pages/ArchivePhotoDetailPage";
import ArchiveDataDetailPage from "./components/pages/ArchiveDataDetailPage";
import ArchivePhotoPage from "./components/pages/ArchivePhotoPage";
import { verifyToken } from "./components/api/api";

/*const ProtectedRoute = ({ redirectPath = "" }: any) => {
  if (!localStorage.getItem("token")) {
    return <Navigate to={redirectPath} replace />;
  } else {
    const jwtParts = localStorage.getItem("token")?.split(".");
    if (jwtParts && jwtParts.length > 1) {
      const payloadInBase64UrlFormat = jwtParts[1];

      verifyToken()
        .then((x) => {
          console.log("ok", x);
          const decodedPayload = atob(payloadInBase64UrlFormat);
          const jsonPayload = JSON.parse(decodedPayload);
          let exp = moment.unix(jsonPayload.exp).toISOString();
          if (moment().isAfter(exp)) {
            return <Navigate to={redirectPath} replace />;
          } else {
            return <Outlet />;
          }
        })
        .catch((e) => {
          console.log("error", e);
          localStorage.clear();
          return <Navigate to={redirectPath} replace />;
        });
    } else {
      return <Navigate to={redirectPath} replace />;
    }
  }
};*/

const ProtectedRoute = ({ redirectPath = "/" }: { redirectPath?: string }) => {
  const [status, setStatus] = useState<"checking" | "valid" | "invalid">(
    "checking"
  );
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setStatus("invalid");
      return;
    }

    const parts = token.split(".");
    if (parts.length < 2) {
      setStatus("invalid");
      return;
    }

    try {
      const payload = JSON.parse(atob(parts[1]));
      const exp = moment.unix(payload.exp);
      if (moment().isAfter(exp)) {
        setStatus("invalid");
        return;
      }

      verifyToken()
        .then(() => setStatus("valid"))
        .catch(() => {
          localStorage.clear();
          setStatus("invalid");
        });
    } catch (err) {
      console.error("Errore decoding token", err);
      setStatus("invalid");
    }
  }, [location]);

  if (status === "checking") {
    return <div>Verifica in corso...</div>; // o uno spinner
  }

  if (status === "invalid") {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

function useDynamicEnvironment() {
  const [environment, setEnvironment] = useState(null);
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((env) => {
        Environment.config = env;
        setEnvironment(env);
      });
  }, []);
  return environment;
}

function App() {
  const dispatch = useDispatch();
  const environment: any = useDynamicEnvironment();
  const [user, setUser] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("token");
    dispatch(setUsername(null));
  };

  if (!environment) {
    return (
      <div className="flex bg-primary align-center items-center justify-center w-full h-full">
        <TailSpin color="#FFFFFF" height="100" width="100" />
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* ROTTE PROTETTE */}
        <Route element={<ProtectedRoute redirectPath="/" />}>
          <Route
            path="region"
            element={<RegionPage handleLogout={handleLogout} />}
          />
          <Route
            path="home"
            element={<HomePage handleLogout={handleLogout} />}
          />
          <Route
            path="archive/photo/:idHeliport"
            element={<ArchivePhotoDetailPage handleLogout={handleLogout} />}
          />
          <Route
            path="archive/data/:idHeliport"
            element={<ArchiveDataDetailPage handleLogout={handleLogout} />}
          />
          <Route
            path="archive/photos"
            element={<ArchivePhotoPage handleLogout={handleLogout} />}
          />
          <Route
            path="archive/data"
            element={<ArchiveDataPage handleLogout={handleLogout} />}
          />
          <Route
            path="heliports"
            element={<HeliportsPage handleLogout={handleLogout} />}
          />
          <Route
            path="dashboard/:idHeliport"
            element={<DashboardPage handleLogout={handleLogout} />}
          />
        </Route>

        {/* ROTTA NON PROTETTA: LOGIN */}
        <Route path="/" element={<LoginPage setUser={setUser} />} />

        {/* NOT FOUND */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
